import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Tab, Tabs, Tag } from "@blueprintjs/core";
import { flatMap, isNumber, startCase } from "lodash-es";
import FeatureProperties from "./FeatureProperties";
import GeneralProperties from "./GeneralProperties";
import CutsiteProperties from "./CutsiteProperties";
import OrfProperties from "./OrfProperties";
import GenbankView from "./GenbankView";
import TranslationProperties from "./TranslationProperties";
import PrimerProperties from "./PrimerProperties";
import PartProperties from "./PartProperties";
import withEditorProps from "../../withEditorProps";
import "./style.css";
import { userDefinedHandlersAndOpts } from "../../Editor/userDefinedHandlersAndOpts";
import { pick } from "lodash-es";
const PropertiesContainer = (Comp) => (props) => {
  const { additionalFooterEls, additionalHeaderEls, overrideEl, ...rest } = props;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    additionalHeaderEls,
    overrideEl || /* @__PURE__ */ jsx(Comp, { ...rest }),
    additionalFooterEls
  ] });
};
const allTabs = {
  general: PropertiesContainer(GeneralProperties),
  features: PropertiesContainer(FeatureProperties),
  parts: PropertiesContainer(PartProperties),
  primers: PropertiesContainer(PrimerProperties),
  translations: PropertiesContainer(TranslationProperties),
  cutsites: PropertiesContainer(CutsiteProperties),
  orfs: PropertiesContainer(OrfProperties),
  genbank: PropertiesContainer(GenbankView)
};
export const PropertiesDialog = (props) => {
  const {
    propertiesTool = {},
    propertiesViewTabUpdate,
    dimensions = {},
    height,
    editorName,
    onSave,
    showReadOnly,
    showAvailability,
    isProtein,
    annotationsToSupport = {},
    disableSetReadOnly,
    propertiesList = [
      "general",
      "features",
      "parts",
      "primers",
      "translations",
      "cutsites",
      "orfs",
      "genbank"
    ],
    closePanelButton
  } = { ...props, ...props.PropertiesProps };
  const { width, height: heightFromDim } = dimensions;
  let { tabId, selectedAnnotationId } = propertiesTool;
  if (propertiesList.map((nameOrOverride) => nameOrOverride.name || nameOrOverride).indexOf(tabId) === -1) {
    tabId = propertiesList[0].name || propertiesList[0];
  }
  const getAnnotationCount = (name) => {
    const annotations = props[name] || props.sequenceData[name];
    let count;
    if (Array.isArray(annotations)) {
      count = annotations.length;
    } else if (annotations && typeof annotations === "object") {
      count = Object.keys(annotations).length;
    }
    if (isNumber(count)) {
      return /* @__PURE__ */ jsx(Tag, { className: "tg-smallTag", round: true, style: { marginLeft: 1 }, children: count });
    }
    return null;
  };
  const propertiesTabs = flatMap(propertiesList, (nameOrOverride) => {
    if (annotationsToSupport[nameOrOverride] === false) {
      return [];
    }
    const name = nameOrOverride.name || nameOrOverride;
    const Comp = nameOrOverride.Comp || allTabs[name];
    if (isProtein) {
      if (name === "translations" || name === "orfs" || name === "primers" || name === "cutsites") {
        return null;
      }
    }
    const count = getAnnotationCount(name);
    let title = (() => {
      if (nameOrOverride.Comp) return name;
      if (name === "orfs") return "ORFs";
      if (name === "cutsites") return "Cut Sites";
      return startCase(name);
    })();
    if (count) {
      title = /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
        title,
        count
      ] });
    }
    return /* @__PURE__ */ jsx(
      Tab,
      {
        title,
        id: name,
        panel: /* @__PURE__ */ jsx(
          Comp,
          {
            ...{
              ...pick(props, userDefinedHandlersAndOpts),
              editorName,
              onSave,
              isProtein,
              showReadOnly,
              showAvailability,
              disableSetReadOnly,
              selectedAnnotationId,
              PropertiesProps: props.PropertiesProps,
              ...nameOrOverride.name && nameOrOverride
            }
          }
        )
      },
      name
    );
  });
  const heightToUse = Math.max(0, Number((heightFromDim || height) - 30));
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        position: "relative"
      },
      children: [
        closePanelButton,
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "ve-propertiesPanel",
            style: {
              display: "flex",
              width,
              height: heightToUse || 300,
              zIndex: 10,
              padding: 10
              // paddingBottom: '31px',
            },
            children: propertiesTabs.length ? /* @__PURE__ */ jsxs(
              Tabs,
              {
                style: { width },
                renderActiveTabPanelOnly: true,
                selectedTabId: tabId,
                onChange: propertiesViewTabUpdate,
                children: [
                  /* @__PURE__ */ jsx(Tabs.Expander, {}),
                  propertiesTabs,
                  /* @__PURE__ */ jsx(Tabs.Expander, {})
                ]
              }
            ) : /* @__PURE__ */ jsx("div", { style: { margin: 20, fontSize: 20 }, children: "No Properties to display" })
          }
        )
      ]
    }
  );
};
export default withEditorProps(PropertiesDialog);
